import { render } from "./Signup.vue?vue&type=template&id=0afcf639&scoped=true"
import script from "./Signup.vue?vue&type=script&lang=js"
export * from "./Signup.vue?vue&type=script&lang=js"

import "./Signup.vue?vue&type=style&index=0&id=0afcf639&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-0afcf639"

export default script